import Vue from 'vue'
import Router from 'vue-router'
import Hero from '@/components/Hero'
import Overview from '@/components/Overview'
import Assemble from '@/components/assemble/Assemble'
import Create from '@/components/assemble/create/Create'
import Team from '@/components/assemble/Team'
import Tickets from '@/components/assemble/Tickets'
import Compete from '@/components/compete'
import Scouting from '@/components/compete/Scouting'
import ChampSelect from '@/components/compete/ChampSelect'
import Triumph from '@/components/triumph/Triumph'
import Bracket from '@/components/triumph/Bracket'
import Ticket from '@/components/Ticket'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'hero',
      meta: {
        track: 'Homepage'
      },
      component: Hero
    },
    {
      path: '/overview',
      name: 'overview',
      meta: {
        track: 'Overview'
      },
      component: Overview
    },
    {
      path: '/assemble',
      name: 'assemble',
      meta: {
        track: 'Team Up (Overview)'
      },
      component: Assemble
    },
    {
      path: '/assemble/create',
      name: 'create',
      meta: {
        track: 'Team Up (Team Name and Logo)'
      },
      component: Create,
      children: [
        {
          path: 'logo',
          name: 'logo'
        },
        {
          path: 'name',
          name: 'name',
          beforeEnter: (to, from, next) => {
            if (window.clash2018.region === 'jp' || window.clash2018.region === 'ru' || window.clash2018.region === 'kr') {
              next('/assemble/create')
            } else {
              next()
            }
          }
        }
      ]
    },
    {
      path: '/assemble/team',
      name: 'createteam',
      meta: {
        track: 'Team Up (Invite Your Team)'
      },
      component: Team
    },
    {
      path: '/assemble/tickets',
      name: 'createtickets',
      meta: {
        track: 'Team Up (Ticket Entry)'
      },
      component: Tickets
      // beforeEnter: (to, from, next) => {
      //   if (window.clash2018.region === 'zh') {
      //     next('/compete')
      //   } else {
      //     next()
      //   }
      // }
    },
    {
      path: '/compete',
      name: 'compete',
      meta: {
        track: 'Scout Opponent (Overview)'
      },
      component: Compete
    },
    {
      path: '/compete/scouting',
      name: 'scouting',
      meta: {
        track: 'Scout Opponent (View Opponent Stats)'
      },
      component: Scouting,
      children: [
        {
          path: 'details',
          name: 'details',
          meta: {
            track: 'Scout Opponent (View Opponent Stats)'
          }
        }
      ]
    },
    {
      path: '/compete/champselect',
      name: 'champselect',
      meta: {
        track: 'Pick Your Champs'
      },
      component: ChampSelect
    },
    {
      path: '/triumph',
      name: 'triumph',
      meta: {
        track: '4-Team Bracket (Overview)'
      },
      component: Triumph
    },
    {
      path: '/triumph/bracket',
      name: 'bracket',
      meta: {
        track: '8-Team Bracket (Compete)'
      },
      component: Bracket,
      children: [
        {
          path: 'rewards',
          name: 'rewards',
          meta: {
            track: '8-Team Bracket (Rewards)'
          }
        }
      ]
    },
    {
      path: '/ticket',
      name: 'ticket',
      meta: {
        track: 'Your Free Ticket'
      },
      component: Ticket,
      children: [
        {
          path: 'claim',
          name: 'ticketclaim',
          meta: {
            track: 'Ticket Payout'
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js